<template>
  <input
    type="text"
    placeholder="コメントする"
    class="comment_input"
    @click.prevent="showModal()"
  >
  <button class="button" @click.prevent="showModal()">投稿</button>
  <div class="form formSignupAppeal" v-if="show" @click.self="closeModal">
    <div class="box">
      <div class="contents">
        <div class="signupAppeal">
          <h3>
            <slot></slot>
          </h3>
          <div class="next">
            <a class="button" href="/register">登録へ進む</a>
            <a class="textLink" href="/login">アカウントをお持ちの方はこちら</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
